import { Info } from 'lucide-react'
import { Link } from 'react-router-dom'

import { paths } from 'src/config/paths'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'src/shared/components/ui/miscellaneous/tooltip'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'
import { useIsMobile } from 'src/shared/hooks/use-mobile'
import { cn } from 'src/shared/utils/cn'

import { VisibilityBlankDark } from '../../assets/visibility-blank-dark'
import { VisibilityDark } from '../../assets/visibility-dark'

export const VisibilityCard = () => {
  const { data: user } = useMyUserData()
  const isMobile = useIsMobile()

  const score = user?.visibilityScore || 1

  if (!user || user.profileComplete < 100) {
    return <LockedVisibilityCard />
  }

  return (
    <div
      className={cn(
        'overflow-hidden rounded-3xl border bg-card shadow-sm',
        isMobile ? 'mx-auto w-full' : 'mx-4 w-[calc(100%-2rem)]',
      )}
    >
      <div className="px-4 pt-3">
        <div className="mb-3 flex items-center justify-between gap-1">
          <div className="flex items-center gap-1">
            <div className="relative">
              <VisibilityBlankDark className="size-10" />
              <span className="absolute left-1/2 top-[22px] -translate-x-1/2 -translate-y-1/2 font-bold text-primary-foreground">
                {score}
              </span>
            </div>
            <h2 className={cn('text-base font-semibold', isMobile ? 'text-base' : 'text-xl')}>Visibility score</h2>
          </div>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="flex items-center">
                  <Info className="size-5 text-muted/50" />
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <p>A higher visibility score makes you more discoverable in the algorithm.</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </div>
    </div>
  )
}

const LockedVisibilityCard = () => {
  return (
    <div className="mx-4 w-[calc(100%-2rem)] overflow-hidden rounded-3xl border bg-card shadow-sm">
      <div className="p-4">
        <div className="mb-3 flex items-center gap-2">
          <VisibilityDark className="size-10" />
          <h2 className="text-xl font-semibold">Unlock Visibility score</h2>
        </div>
        <p className="mb-4 text-sm text-muted">
          A higher visibility score makes you more discoverable in the algorithm.
        </p>
        <Link
          to={paths.users.completeProfile.getHref()}
          className="block w-full rounded-full bg-primary py-3 text-center font-medium text-primary-foreground hover:bg-primary/90"
        >
          Get verified
        </Link>
      </div>
    </div>
  )
}
